import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Implemented Chris' double surface refraction...`}</p>
    <h1>{`Refraction`}</h1>
    <p>{`I would like to say, people’s (as least for people who did not see that before 🙂) eyes are really forgiving. I originally planned to do some research on RenderMonkey’s ToolSuite SDK to precompute normal distance Wyman `}{`[2005]`}{`. Now, without any precomputation, but crude and direct approximation. These pictures are only beautiful in pictures and too ugly in theory🙂. I think it could be used in game.`}</p>
    <p>{`Since there are no work worth mentioning, just show some pictures.`}</p>
    <h1>{`Single Refraction`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "339px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/17bb31ca70196b0f1287189685540a64/a6c07/teapot-refraction-single.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "94%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAATABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIEBQED/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDBP/aAAwDAQACEAMQAAABqR9KYeC4I3cYx24Lr//EAB4QAAMAAAcBAAAAAAAAAAAAAAECAwAQERITITNB/9oACAEBAAEFApUZGo3JkQyT7OKPuNfL4qjT/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAx/9oACAEDAQE/AUhk/8QAFxEAAwEAAAAAAAAAAAAAAAAAAQMQEf/aAAgBAgEBPwEHYqf/xAAbEAABBAMAAAAAAAAAAAAAAAABAhARIQAgMf/aAAgBAQAGPwKU5KjbFq4BGn//xAAcEAEAAgMAAwAAAAAAAAAAAAABABEhMVFBYXH/2gAIAQEAAT8hRY8VaRXZR2UyvChd99QNVspfEDG5t+QMyIyJ/9oADAMBAAIAAwAAABBHAML/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQwf/aAAgBAwEBPxCDjRGdM//EABgRAQADAQAAAAAAAAAAAAAAAAABESEx/9oACAECAQE/EKWSxxK3/8QAHRABAAICAwEBAAAAAAAAAAAAAQARITFBYYFRsf/aAAgBAQABPxChJZLG5Vhjto+BqAGkuDOKlFhrTvnyXAKDOP2M8AgUGhlfbgAgA6QDgGhY2RaaMz//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 1: Teapot Single Refraction",
            "title": "Figure 1: Teapot Single Refraction",
            "src": "/static/17bb31ca70196b0f1287189685540a64/a6c07/teapot-refraction-single.jpg",
            "srcSet": ["/static/17bb31ca70196b0f1287189685540a64/75985/teapot-refraction-single.jpg 150w", "/static/17bb31ca70196b0f1287189685540a64/f93b5/teapot-refraction-single.jpg 300w", "/static/17bb31ca70196b0f1287189685540a64/a6c07/teapot-refraction-single.jpg 339w"],
            "sizes": "(max-width: 339px) 100vw, 339px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 1: Teapot Single Refraction`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "279px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/419ba287399db2b43180860d35920c75/0c3ba/sphere-refraction-single.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "114.00000000000001%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAXABQDASIAAhEBAxEB/8QAGgABAAIDAQAAAAAAAAAAAAAAAAQFAQIDBv/EABgBAAIDAAAAAAAAAAAAAAAAAAACAQME/9oADAMBAAIQAxAAAAGTV7RxuL0oijwU6AZP/8QAHBAAAwACAwEAAAAAAAAAAAAAAQIDABESEyIj/9oACAEBAAEFAvnJbN3U0cntp+iYgpMo88BLLxz/xAAYEQADAQEAAAAAAAAAAAAAAAAAAQIQEf/aAAgBAwEBPwHLlJnD/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERAhD/2gAIAQIBAT8Bt5nTaKf/xAAcEAACAgMBAQAAAAAAAAAAAAAAAQIRAyExEhD/2gAIAQEABj8CWTLL3JlrSODrcuI81wSjRZS0vn//xAAdEAEAAQQDAQAAAAAAAAAAAAABABEhQXExUYGR/9oACAEBAAE/Ie8BMygDgINwnyAEUChtgZ1ckf7u7gN3xluWUDncaJ//2gAMAwEAAgADAAAAEFc/AP/EABcRAQEBAQAAAAAAAAAAAAAAAAEAETH/2gAIAQMBAT8QwO2QAJF//8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAECAQE/EFKy0LCv/8QAHxABAQACAgEFAAAAAAAAAAAAAREAITFBcVFhgcHR/9oACAEBAAE/EBLBY9vH65bRyKV9evfB6UaonGJEwcUWfAZGEAo1ANrit0Kqctv0YoGsiwY9Yoo3VD5uXCUz/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 1: Sphere Single Refraction",
            "title": "Figure 1: Sphere Single Refraction",
            "src": "/static/419ba287399db2b43180860d35920c75/0c3ba/sphere-refraction-single.jpg",
            "srcSet": ["/static/419ba287399db2b43180860d35920c75/75985/sphere-refraction-single.jpg 150w", "/static/419ba287399db2b43180860d35920c75/0c3ba/sphere-refraction-single.jpg 279w"],
            "sizes": "(max-width: 279px) 100vw, 279px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 1: Sphere Single Refraction`}</figcaption>{`
  `}</figure>
    <h1>{`Double Refraction`}</h1>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "345px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4ffc1ebdaa010f31d60a944bf5497129/8d48c/teapot-refraction-double.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "98%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQFAwb/xAAYAQADAQEAAAAAAAAAAAAAAAABAgMABP/aAAwDAQACEAMQAAABmpm2s3mFgDYyzlvyF0//xAAaEAADAAMBAAAAAAAAAAAAAAABAgMAERMi/9oACAEBAAEFAoOVrVK2AySDo8fDsNvrkSSABn//xAAWEQADAAAAAAAAAAAAAAAAAAABIDH/2gAIAQMBAT8BNT//xAAXEQADAQAAAAAAAAAAAAAAAAABAxAh/9oACAECAQE/AQci5//EACAQAAEDAwUBAAAAAAAAAAAAAAEAAhEQEnEDISIxQUL/2gAIAQEABj8C4CSnF3x5QXktwt9R8ZQtAgBdBQXE0//EABoQAQADAQEBAAAAAAAAAAAAAAEAESExUWH/2gAIAQEAAT8hJttgTLuHEWYDx9QVFYbcPCuC66wDxGZFoL63K0//2gAMAwEAAgADAAAAEHQ3Pv/EABgRAQEBAQEAAAAAAAAAAAAAAAEAESFR/9oACAEDAQE/EDnVjHTX1m//xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8QBhuM/8QAHRABAAICAwEBAAAAAAAAAAAAAQARIUExUWGRcf/aAAgBAQABPxAJYlPsvCCbAA4uw39jbZ3D7xqJ2vr2FAOVoO4oAgGtl+srBsDkfkCM+B4U8OGuZ//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 2: Teapot Double Refraction",
            "title": "Figure 2: Teapot Double Refraction",
            "src": "/static/4ffc1ebdaa010f31d60a944bf5497129/8d48c/teapot-refraction-double.jpg",
            "srcSet": ["/static/4ffc1ebdaa010f31d60a944bf5497129/75985/teapot-refraction-double.jpg 150w", "/static/4ffc1ebdaa010f31d60a944bf5497129/f93b5/teapot-refraction-double.jpg 300w", "/static/4ffc1ebdaa010f31d60a944bf5497129/8d48c/teapot-refraction-double.jpg 345w"],
            "sizes": "(max-width: 345px) 100vw, 345px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 2: Teapot Double Refraction`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "307px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/f07226121a2bcdbe437c6f4977f6b351/6bde8/sphere-refraction-double.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "109.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAWABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMFBP/EABYBAQEBAAAAAAAAAAAAAAAAAAACA//aAAwDAQACEAMQAAABvlulXC1xnyMd6io//8QAGhAAAgMBAQAAAAAAAAAAAAAAAgMAARITEf/aAAgBAQABBQKmqSph9mUoyiy8AkDwWwAAk5lDqZn/xAAXEQADAQAAAAAAAAAAAAAAAAABAhAR/9oACAEDAQE/AY4wz//EABcRAAMBAAAAAAAAAAAAAAAAAAECECH/2gAIAQIBAT8BinJ//8QAHhAAAgEEAwEAAAAAAAAAAAAAAAECERIhIhATYVH/2gAIAQEABj8CThtJlZYNY1RJfTsut8ElNelUzPH/xAAeEAEAAgEEAwAAAAAAAAAAAAABABFBEDFRYSFxsf/aAAgBAQABPyEFuziU2742hCpZVkUwHLmupVO58j+Qa7PtEODGV6P/2gAMAwEAAgADAAAAEFfvgP/EABcRAQEBAQAAAAAAAAAAAAAAAAEAETH/2gAIAQMBAT8QwO2QAE3/xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAECAQE/EFXthI6bb//EACAQAQACAgEEAwAAAAAAAAAAAAEAESFBMVFhccGBkdH/2gAIAQEAAT8QrKurVK3br3KFCoBh9vcPNlQgcUnWNnuq/F3CmdvMaG178RtEGQcrL+fEZ+ESXwMYC41eSf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 2: Sphere Double Refraction",
            "title": "Figure 2: Sphere Double Refraction",
            "src": "/static/f07226121a2bcdbe437c6f4977f6b351/6bde8/sphere-refraction-double.jpg",
            "srcSet": ["/static/f07226121a2bcdbe437c6f4977f6b351/75985/sphere-refraction-double.jpg 150w", "/static/f07226121a2bcdbe437c6f4977f6b351/f93b5/sphere-refraction-double.jpg 300w", "/static/f07226121a2bcdbe437c6f4977f6b351/6bde8/sphere-refraction-double.jpg 307w"],
            "sizes": "(max-width: 307px) 100vw, 307px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 2: Sphere Double Refraction`}</figcaption>{`
  `}</figure>
    <p>{`More pictures:`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "202px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/26b64e5652bd4709e3e96d0d97c6d8c8/94f90/lucid-refraction-double.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "221.99999999999997%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAsABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAABAAFAgP/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAMAwEAAhADEAAAAeB8Npz71ofN4GJoQYTrSijBtuN//8QAHhAAAgICAgMAAAAAAAAAAAAAAQIAAwQREhMiMTL/2gAIAQEAAQUCybQ5KNoRPIpfqltE1/WI6KSa4nuioPOhYo4Ho5VsWY5ChpSeKWaZv//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BX//EABYRAQEBAAAAAAAAAAAAAAAAABAhAf/aAAgBAgEBPwHax//EACMQAAEDAgUFAAAAAAAAAAAAAAEAAhEQIQMSIjGBEzIzQXH/2gAIAQEABj8CDW9oUhtIXTnZWFqOGJHKsGUM3+LyDlGTlKD8E39rVugYutIAUloX/8QAHRABAAICAwEBAAAAAAAAAAAAAQARITFBUWEQcf/aAAgBAQABPyEvTt7l6qjbLVDlcncS66VWGaiS1dPhsy9LispPGb+KJi/Qcsko4PNpgHopIWlQYe+TqJiNqDxAMtN43Bcd/J//2gAMAwEAAgADAAAAEFcuchDf/8QAFxEAAwEAAAAAAAAAAAAAAAAAEBEgMf/aAAgBAwEBPxDIY//EABgRAAIDAAAAAAAAAAAAAAAAAAERABAh/9oACAECAQE/ECbKEcELa//EAB0QAQADAAMBAQEAAAAAAAAAAAEAESExQVFxgdH/2gAIAQEAAT8QPaXllv5FJPHFh+y5a8wV1wHFL3KaaAFXjcrn8immcUSWKsF2VRiqOKuriYuHNELYOhvya8ZxFHbruPAvbRQ+wQEbSlM+cbCGtm4+n1LQ1E2U0ey+mEXFylTLRpesv8oW9p//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 3: Lucid Double Refraction",
            "title": "Figure 3: Lucid Double Refraction",
            "src": "/static/26b64e5652bd4709e3e96d0d97c6d8c8/94f90/lucid-refraction-double.jpg",
            "srcSet": ["/static/26b64e5652bd4709e3e96d0d97c6d8c8/75985/lucid-refraction-double.jpg 150w", "/static/26b64e5652bd4709e3e96d0d97c6d8c8/94f90/lucid-refraction-double.jpg 202w"],
            "sizes": "(max-width: 202px) 100vw, 202px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 3: Lucid Double Refraction`}</figcaption>{`
  `}</figure>


    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "306px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/8e2a9334a738015c1b8954394ac71f3d/01fdd/elephant-refraction-double.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "115.33333333333333%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAXABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIEBQED/8QAFgEBAQEAAAAAAAAAAAAAAAAAAgMA/9oADAMBAAIQAxAAAAGFeFjPPbjHxpkK9FR//8QAGxAAAgMAAwAAAAAAAAAAAAAAAQIAAxEEEhP/2gAIAQEAAQUCrtcUWa4ijVfa4OMpDV+Jwlu9k//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABcRAAMBAAAAAAAAAAAAAAAAAAEQEQL/2gAIAQIBAT8BqwTF/8QAHRABAAICAgMAAAAAAAAAAAAAAQACETEQIjJhkv/aAAgBAQAGPwJKpX3CzldZ4IB8s77lbGhmZ5M//8QAGxAAAgMBAQEAAAAAAAAAAAAAAREAITFRYYH/2gAIAQEAAT8hDegdbGY3CxxKEuUSgPYCA2ekGSB7RQ+QVxaUKqSnXY3zrZ//2gAMAwEAAgADAAAAEHAQ/f/EABgRAQEBAQEAAAAAAAAAAAAAABEBABAh/9oACAEDAQE/EA95SlMb/8QAGBEBAQADAAAAAAAAAAAAAAAAAQAQESH/2gAIAQIBAT8QUuEdtu//xAAfEAEAAgICAgMAAAAAAAAAAAABESEAMUFRYXGR0eH/2gAIAQEAAT8QpQiaGvB95U/BefQ+sHtJNk4NhG2IRFvb+YChtPulMcb14yWLlYB6HRr5xAOL7eG8cniTUPBY5xrSFUyrP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Figure 4: Elephant Double Refraction",
            "title": "Figure 4: Elephant Double Refraction",
            "src": "/static/8e2a9334a738015c1b8954394ac71f3d/01fdd/elephant-refraction-double.jpg",
            "srcSet": ["/static/8e2a9334a738015c1b8954394ac71f3d/75985/elephant-refraction-double.jpg 150w", "/static/8e2a9334a738015c1b8954394ac71f3d/f93b5/elephant-refraction-double.jpg 300w", "/static/8e2a9334a738015c1b8954394ac71f3d/01fdd/elephant-refraction-double.jpg 306w"],
            "sizes": "(max-width: 306px) 100vw, 306px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Figure 4: Elephant Double Refraction`}</figcaption>{`
  `}</figure>
    <h1>{`References`}</h1>
    <p>{`[2005]`}{` C Wyman. An approximate image-space approach for interactive refraction. pages 1050–1053. ACM, 2005.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      